module.exports = __webpack_public_path__ + "static/img/3a.becb49c7.png";